module.exports = __webpack_public_path__ + "img/pt-single-5.c6b61d91.jpg";